<template>
  <b-card id="container-entities">
    <div class="row">
      <h3 class="col-12">Almacenes</h3>
      <div class="col-12">
        <WareHousesFilters
          :value="filters"
          :onChange="onChangeFilters"
          :clear="clearFilters"
        />
      </div>
      <div class="col-12 text-left mb-3">
        <b-button
          pill
          variant="primary"
          size="sm"
          v-has-permission="'ED208'"
          @click="addWareHouse()"
          data-cy="add"
        >
          <b-icon icon="plus-circle-fill"></b-icon>
          Agregar Almacén
        </b-button>
      </div>
    </div>
    <div class="row">
      <b-table
        hover
        :fields="fieldWareHouses"
        :items="filteredWareHouses"
        :tbody-tr-attr="{'data-cy': 'file'}"
      >
        <template #cell(actions)="row">
          <div class="row justify-content-end">
            <div v-tooltip="'Editar Almacén'">
              <b-icon
                class="h3 m-2"
                icon="pencil"
                v-has-permission="'ED209'"
                v-on:click.stop.prevent="editWareHouse(row.item)"
                data-cy="edit"
              />
            </div>
            <div v-tooltip="'Eliminar Almacén'">
              <b-icon
                class="h3 m-2"
                v-has-permission="'ED210'"
                icon="trash"
                v-on:click.stop.prevent="showAlertDeleteWareHouse(row.item)"
                data-cy="remove"
              />
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando
          <select v-model="rowspp" @change="fetchWareHouses()">
            <option value="10" selected="selected">10</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <WareHousesPagination
          :show="pagination.pages"
          v-model="page"
        />
      </div>
    </div>
    <b-modal
      id="new-entity"
      ref="newEntity"
      :title="newitem.isEdit?'Editar Almacén':'Nuevo Almacén'"
      hide-footer
      no-close-on-backdrop
    >
      <div class="row mb-5">
        <form data-vv-scope="newitem" class="col-12">
          <div class="col-md-12 mt-3">
            <label>Código</label>
            <b-form-input
              placeholder="Ingresa Código"
              size="md"
              v-model="newitem.code"
              name="code"
              :state="errors.has('newitem.code') ? false : null"
              v-validate="'required'"
            />
            <b-form-invalid-feedback>
              {{ errors.first('newitem.code') }}
            </b-form-invalid-feedback>
          </div>
          <div class="col-md-12 mt-3">
            <label>Nombre</label>
            <b-form-input
              placeholder="Ingresa Nombre"
              size="md"
              v-model="newitem.name"
              name="name"
              :state="errors.has('newitem.name') ? false : null"
              v-validate="'required'"
            />
            <b-form-invalid-feedback>
              {{ errors.first('newitem.name') }}
            </b-form-invalid-feedback>
          </div>
          <div class="col-md-12 mt-3">
            <b-button
              data-cy="next-button"
              class="btn btn-primary pull-right ml-3 mt-5"
              size="md"
              @click="saveWareHouse()"
            >
              <feather-icon icon="SaveIcon"/>
              Guardar
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import { uuid } from 'vue-uuid';
import { mapActions, mapGetters } from 'vuex';

import WareHousesPagination from '@/febos/aduanas/management/warehouses/views/components/WareHousesPagination';
import WareHousesFilters from '@/febos/aduanas/management/warehouses/views/components/WareHousesFilters';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';

export default {
  components: {
    WareHousesFilters,
    WareHousesPagination,
  },
  data() {
    return {
      list: [],
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      newitem: { parameters: [] },
      filters: '',
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchWareHouses();
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#container-entities > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#container-entities',
        scale: 0.6
      });
    },
  },
  computed: {
    ...mapGetters('warehouses', [
      'listWareHouses',
      'loading',
      'pagination',
      'fieldWareHouses'
    ]),
    filteredWareHouses() {
      return this.listWareHouses;
    }
  },
  methods: {
    ...mapActions('warehouses', [
      'saveNewWareHouse',
      'loadListWareHouses'
    ]),
    showAlertDeleteWareHouse(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: '¿Estás seguro que deseas eliminar el almacen '.concat(item.descripcion).concat('?'),
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.saveDeleteWareHouse(item)
      });
    },
    async saveDeleteWareHouse(item) {
      const param = {
        holding: 'si',
        id: item.opcionId
      };
      const body = {
        grupoId: 'io.aduanas.almacenes',
        parametroId: item.parametroId,
        deshabilitado: 1,
      };
      await this.saveNewWareHouse({ param, body });
      this.$refs.newEntity.hide();
      await this.fetchWareHouses();
    },
    async fetchWareHouses() {
      const body = {
        grupoOpcion: 'io.aduanas.almacenes',
        filtros: this.getFilters(),
        pagina: this.page,
        itemsPorPagina: this.rowspp,
      };
      await this.loadListWareHouses(body);
    },
    editWareHouse(item) {
      this.newitem = {
        opcionId: item.opcionId,
        parametroId: item.parametroId,
        name: item.descripcion,
        code: item.valor,
        isEdit: true
      };
      this.$refs.newEntity.show();
    },
    async saveWareHouse() {
      const isValid = await this.validateForm('newitem');
      if (!isValid) {
        return;
      }
      let param = {
        holding: 'si'
      };
      let body = {
        grupoId: 'io.aduanas.almacenes',
        descripcion: this.newitem.name,
        valor: this.newitem.code
      };
      if (this.newitem.isEdit) {
        param = {
          ...param,
          id: this.newitem.opcionId
        };
        body = {
          ...body,
          parametroId: this.newitem.parametroId
        };
      } else {
        body = {
          ...body,
          parametroId: uuid.v4(),
          orden: this.pagination.items + 1,
          deshabilitado: 0,
        };
      }
      await this.saveNewWareHouse({ param, body });
      this.$refs.newEntity.hide();
      await this.fetchWareHouses();
    },
    addWareHouse() {
      this.newitem = {
        code: '',
        name: '',
        isEdit: false
      };
      this.$refs.newEntity.show();
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 0 });
      this.$router.go();
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('opcionId')) {
          return this.$route.query.filters;
        }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchWareHouses();
        }
      }
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
  },
  mounted() {
    this.fetchWareHouses();
  },
};
</script>
